

























import { Models } from '@mtap-smartcity/api';
import {
  Component, Vue, Prop, PropSync, Watch
} from 'vue-property-decorator';
import ScenarioElementChart from './ScenarioElementChart/ScenarioElementChart.vue';
import ScenarioElementChartRule from './ScenarioElementChartRule.vue';
import { bisector } from 'd3';

@Component({
  components: {
    ScenarioElementChart,
    ScenarioElementChartRule,
  }
})
export default class ScenarioElementModalGraph extends Vue {
  @PropSync('changes') changesSynced!: Models.ScenarioGraphs.Model['changes']

  @Prop({ type: Object, required: true }) sunriseSunsetRanges!: Models.Scenarios.SunriseSunsetRange

  graphRules: Models.ScenarioGraphs.Rule[] = [];

  graphRulesHandlers = {
    addNewRule: (rule: Models.ScenarioGraphs.Rule) => this.addNewRule(rule),
    modifyChanges: (ruleData: Models.ScenarioGraphs.Rule) => this.modifyChanges(ruleData),
    modifyRuleTime: (timeData: { oldOffset: number; newOffset: number; duty: number }) => this.modifyRuleTime(timeData),
    removeRule: (offset: number) => this.removeRule(offset)
  }

  freshSunriseSunsetRange = true;

  @Watch('sunriseSunsetRanges')
  onSunriseSunsetRangeChange() {
    this.freshSunriseSunsetRange = false;
    this.$nextTick(() => {
      // Add the component back in
      this.freshSunriseSunsetRange = true;
    });
  }

  rulesFromArr(dutyArr: number[]) {
    const rules: Models.ScenarioGraphs.Rule[] = [];
    let currDuty = dutyArr[0];
    let offset = 0;
    rules.push({ offset, duty: currDuty });
    for (let i = 1; i < dutyArr.length; i += 1) {
      const duty = dutyArr[i];
      if (duty !== currDuty) {
        currDuty = duty;
        offset = i;
        rules.push({ offset, duty });
      }
    }
    return rules;
  }

  addNewRule({ duty, offset }: Models.ScenarioGraphs.Rule) {
    const bisect = bisector((d: any) => d.offset).left;
    const idx = bisect(this.graphRules, offset);
    this.graphRules.splice(idx, 0, { duty, offset });
    this.modifyChanges({ duty, offset });
  }

  removeRule(offset: number) {
    const ruleIndex = this.graphRules.findIndex((r) => r.offset === offset);
    if (ruleIndex !== 0) {
      const { duty } = this.graphRules[ruleIndex - 1];
      this.modifyChanges({ duty, offset });
      this.graphRules.splice(ruleIndex, 1);
    }
  }

  modifyChanges({ duty, offset }: Models.ScenarioGraphs.Rule) {
    const ruleIndex = this.graphRules.findIndex((r) => r.offset === offset);
    if (ruleIndex !== -1) {
      this.graphRules[ruleIndex].duty = duty;
      const changesIndexStart = offset;
      const changesIndexEnd = this.graphRules[ruleIndex + 1]?.offset || this.changesSynced.length;
      for (let i = changesIndexStart; i < changesIndexEnd; i += 1) {
        this.changesSynced[i] = duty;
      }
    }
  }

  modifyRuleTime({ oldOffset, newOffset, duty }: { oldOffset: number; newOffset: number; duty: number }) {
    const ruleIndex = this.graphRules.findIndex((r) => r.offset === oldOffset);
    if (ruleIndex !== -1) {
      const nextRule = this.graphRules[ruleIndex + 1];
      const rangeEnd = nextRule?.offset || this.changesSynced.length;
      const prevDuty = ruleIndex > 0 ? this.graphRules[ruleIndex - 1].duty : duty;

      for (let i = oldOffset; i < rangeEnd; i += 1) {
        this.changesSynced[i] = prevDuty;
      }

      this.graphRules.splice(ruleIndex, 1);
      this.addNewRule({ duty, offset: newOffset });
    }
  }

  addDefaultRule() {
    const lastRule = this.graphRules[this.graphRules.length - 1];
    const newOffset = lastRule.offset + 1;
    const newDuty = 50;
    this.addNewRule({ duty: newDuty, offset: newOffset });
  }

  created() {
    this.graphRules = this.rulesFromArr(this.changesSynced);
  }
}
